import React from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"

import { StoreType } from "client/store"

export const CalculationsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    margin: 0 10px;
    font-family: ${(props) => props.theme.defaultFont};
    font-size: ${(props) => props.theme.fontSizes.sm}px;
`

const SilCalculations = () => {
    const packageUsage = useSelector((state: StoreType) => state.system.packageUsage)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const { maxCalculations, usedCalculations } = packageUsage

    let leftCalculations = ""
    if (maxCalculations === null) leftCalculations = lang.unlimitedCalculationsHeader
    else {
        leftCalculations = lang.leftCalculationsHeader
        .replace("{0}", usedCalculations.toString())
        .replace("{1}", maxCalculations.toString())
    }

    return (
        <CalculationsWrapper>
            {leftCalculations}
        </CalculationsWrapper>
    )
}
export default SilCalculations
